var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmotionGood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 22.5C45 34.9264 34.9264 45 22.5 45C10.0736 45 0 34.9264 0 22.5C0 10.0736 10.0736 0 22.5 0C34.9264 0 45 10.0736 45 22.5Z",
    fill: "url(#paint0_radial_1334_19367)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4095 18.9247C14.6906 16.8386 11.7333 18.0478 10.5906 18.9247C10.4261 19.0509 10.1942 19.0148 10.0726 18.8441C9.95097 18.6733 9.98574 18.4326 10.1502 18.3064C11.4271 17.3265 14.7609 15.9363 17.8498 18.3064C18.0143 18.4326 18.049 18.6733 17.9274 18.844C17.8059 19.0148 17.5739 19.0509 17.4095 18.9247Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.3356 18.9247C31.277 16.8386 27.95 18.0478 26.6644 18.9247C26.4793 19.0509 26.2184 19.0148 26.0816 18.8441C25.9448 18.6733 25.984 18.4326 26.169 18.3064C27.6055 17.3265 31.356 15.9363 34.831 18.3064C35.016 18.4326 35.0552 18.6733 34.9184 18.844C34.7816 19.0148 34.5207 19.0509 34.3356 18.9247Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9675 26.8268C22.4448 26.8454 21.9103 27.1194 21.5808 27.3747C21.4129 27.5047 21.1825 27.4583 21.066 27.2709C20.9496 27.0836 20.9912 26.8263 21.159 26.6963C21.5632 26.3832 22.2343 26.0267 22.9439 26.0014C23.3046 25.9886 23.6844 26.0613 24.0403 26.2799C24.3979 26.4995 24.7088 26.8527 24.9485 27.3596C24.9694 27.404 24.983 27.4522 24.9885 27.502C25.0419 27.9882 24.9216 28.6796 24.3744 29.1547C24.2263 29.2833 24.0533 29.3904 23.8535 29.472C24.4385 29.8568 24.9912 30.4548 24.9912 31.3248C24.9912 31.3637 24.9863 31.4024 24.9766 31.4398C24.8622 31.8801 24.5496 32.455 23.9698 32.7719C23.3753 33.0968 22.5743 33.1107 21.562 32.5767C21.3774 32.4792 21.2984 32.2331 21.3857 32.027C21.4729 31.8208 21.6934 31.7326 21.8781 31.8301C22.7466 32.2883 23.3046 32.216 23.6446 32.0302C23.9748 31.8498 24.1688 31.5252 24.2498 31.2667C24.2243 30.8271 23.9085 30.4366 23.3591 30.109C22.9307 29.8535 22.4279 29.6801 22.0115 29.5806C21.8935 29.5605 21.7715 29.536 21.6456 29.5071C21.4497 29.4621 21.3214 29.2516 21.3557 29.0317C21.3901 28.8118 21.5747 28.6623 21.7726 28.694C21.8855 28.7121 22.0109 28.7366 22.1449 28.7681C23.1275 28.9324 23.6523 28.7355 23.9203 28.5029C24.1892 28.2694 24.2706 27.9374 24.2597 27.6745C24.0867 27.3348 23.8862 27.1277 23.6837 27.0034C23.4658 26.8696 23.2228 26.8177 22.9675 26.8268Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1334_19367",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.5 22.5) rotate(90) scale(22.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9D77F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmotionGood);
export default __webpack_public_path__ + "static/media/EmotionGood.e686d5c38ecb37dcdeefe322d46bf0f3.svg";
export { ForwardRef as ReactComponent };